// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileContainer_container__1k0LI","header":"MobileContainer_header__776vh","placeholder":"MobileContainer_placeholder__m5b9m"};